import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { StepViewModel } from '@app/shared/model/stepViewModel';
import { StepCssClass } from '@clux-models';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-step-sidebar',
  templateUrl: './step-sidebar.component.html',
  styleUrls: ['./step-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class StepSidebarComponent {
  public StepCssClass = StepCssClass;
  @Input() public model: StepViewModel<string, object>;

  public deCamel = (word: string) => word.replace(/([a-z])([A-Z])/g, '$1 $2');
  public isDone = (step: string) => this.model.stepViews.get(step).stepCssClass === StepCssClass.Done;
  // incrementing for every valid step before this one
  public displayStepIdx = (stepIdx: number) => {
    let toRet = 1;
    for (let i = 0; i < stepIdx; i++) {
      toRet += Number(this.model.stepViews.get(this.model.steps[i]).valid);
    }
    return toRet;
  };
}
